import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogInUiConfigService {
  private logInUiConfigValues;

  constructor(private injector: Injector) { }

  async loadLogInUiConfig() {
    let http = this.injector.get(HttpClient);
    const jsonData = http.get('/assets/config/loginPage-config.json');
    this.logInUiConfigValues = await lastValueFrom(jsonData);
  }

  get logInUiConfigVariables() {
    return this.logInUiConfigValues;
  }
}
